import React from "react";

/**
 * Shown when a save was refused because someone else committed first. A
 * question, not a notice: only the user can say which copy wins, and autosave
 * stays paused until they answer.
 */
export const VersionConflictBanner: React.FC<{
  /** Discard this tab's work and re-load the file. */
  onReload: () => void;
  /** Commit this tab's content on top of the version that won. */
  onKeepMine: () => void;
}> = ({ onReload, onKeepMine }) => (
  <div
    style={{
      position: "absolute",
      top: "4.75rem",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 6,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.2rem",
      padding: "0.35rem 0.6rem",
      borderRadius: "0.5rem",
      background: "#fef3c7",
      boxShadow: "var(--shadow-island, 0 1px 4px rgba(0,0,0,0.12))",
      // The canvas container sets pointer-events:none on overlays; the buttons
      // have to opt back in or they cannot be clicked.
      pointerEvents: "auto",
      maxWidth: "calc(100vw - 2rem)",
    }}
  >
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem",
      }}
    >
      <span role="alert" style={{ fontSize: "0.75rem", color: "#92400e" }}>
        This map changed elsewhere.
      </span>
      <button type="button" onClick={onReload} style={buttonStyle}>
        Reload
      </button>
      <button type="button" onClick={onKeepMine} style={buttonStyle}>
        Keep mine
      </button>
    </div>
    {/* "Keep mine" is destructive for the other writer (an agent, another
        tab); the button label alone does not say so. */}
    <span style={{ fontSize: "0.75rem", color: "#92400e", opacity: 0.85 }}>
      Keep mine replaces the changes made elsewhere.
    </span>
  </div>
);

const buttonStyle: React.CSSProperties = {
  fontSize: "0.75rem",
  fontWeight: 500,
  color: "#4f46e5",
  background: "var(--island-bg-color, #fff)",
  border: "none",
  borderRadius: "0.4rem",
  padding: "0.15rem 0.55rem",
  cursor: "pointer",
};
